import { NzTableComponent } from 'ng-zorro-antd/table/public-api';
import { PagedResultModel } from 'mm-web-core/common';
import { SimpleChanges, SimpleChange } from '@angular/core';

export function setPagedResult(table: NzTableComponent, result: PagedResultModel<any>) {

    if (!result) return;
    table.nzData = result.data;
    table.nzPageIndex = result.pageIndex;
    table.nzTotal = result.totalCount;
    table.nzPageSize = result.pageSize;
    

    const changes: SimpleChanges = {
        nzData: new SimpleChange(table.nzData, result.data, false),
        nzPageIndex: new SimpleChange(table.nzPageIndex, result.pageIndex, false),
        nzTotal: new SimpleChange(table.nzTotal, result.totalCount, false),
        nzPageSize: new SimpleChange(table.nzPageSize, result.pageSize, false)
    };
    // changes.nzData=_.data;
    table.ngOnChanges(changes);


}

